import { initializeApp } from "firebase/app";
import { initializeFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";
import { getMessaging } from "firebase/messaging";
import { getFunctions } from "firebase/functions"; // IMPORTAÇÃO OBRIGATÓRIA DA GOOGLE

const firebaseConfig = {
  apiKey: "AIzaSyAdf_Ay8RQNh49uFCn62dnF121AAaYhdaU",
  authDomain: "gamefutlive-882bf.firebaseapp.com",
  projectId: "gamefutlive-882bf",
  storageBucket: "gamefutlive-882bf.firebasestorage.app",
  messagingSenderId: "79611033106",
  appId: "1:79611033106:web:1bafc5fdf52340a2b00acb",
  measurementId: "G-FXNVG2WBT6"
};

// Inicializar o Firebase
const app = initializeApp(firebaseConfig);

// Exportar as ferramentas para usarmos na App
// FORÇA LONG-POLLING: muitos operadores móveis e o proxy/CDN do DigitalOcean fazem
// buffer do stream WebSocket do Firestore. Resultado: o onSnapshot recebia o snapshot
// inicial (valor atual aparecia) mas as atualizações em tempo real nunca chegavam ao
// telemóvel — enquanto no desktop (WebSocket ok) tudo atualizava. O long-polling usa
// pedidos HTTP discretos que os proxies não bufferizam, repondo o tempo real em todos
// os dispositivos (LÍDER, Carteira, Claque, TOP).
export const db = initializeFirestore(app, {
  experimentalForceLongPolling: true,
});
export const storage = getStorage(app);
export const auth = getAuth(app);
// O Safari do iPhone só expõe a API de Push a partir do iOS 16.4 — e mesmo aí,
// apenas quando a app está instalada no ecrã inicial. Chamar getMessaging() num
// telemóvel sem essa API não parte a app, mas deixa cair uma promessa rejeitada
// ("unsupported-browser") em TODOS os arranques, que enchia a consola do iPhone
// e escondia os erros que interessavam. Verificamos primeiro; se não dá, fica a
// null e o Feed.jsx trata disso (o getToken já está dentro de um try/catch).
const suportaPush = () => {
  try {
    return (
      typeof window !== 'undefined' &&
      'serviceWorker' in navigator &&
      'PushManager' in window &&
      'Notification' in window &&
      typeof ServiceWorkerRegistration !== 'undefined' &&
      'showNotification' in ServiceWorkerRegistration.prototype
    );
  } catch {
    return false;
  }
};

export const messaging = suportaPush() ? getMessaging(app) : null;

// CANAL SUPREMO DE SERVIDORES: Força o SDK a abrir uma rota segura com as cabeçalhas certas
export const functions = getFunctions(app, "us-central1");
